import React from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import CustomInput from '@/components/CustomInput/CustomInput';

const replaceCustomInputWithSelect = (node, options) => {
  if (!React.isValidElement(node)) return node;

  if (node.type === CustomInput) {
    const {
      labelText,
      id,
      name,
      value,
      onChange,
      disabled,
      error,
      inputProps,
      formControlProps,
      helperTextStyle: helperStyle,
    } = node.props;
    const helperText = inputProps?.helperText;
    return (
      <div className='custom-select'>
        <FormControl
          {...formControlProps}
          variant='standard'
          error={error}
          disabled={disabled}>
          <InputLabel id={`${id}-label`}>{labelText}</InputLabel>
          <Select
            labelId={`${id}-label`}
            id={id}
            name={name}
            value={value || ''}
            onChange={onChange}
            className='full-width-elem'>
            <MenuItem value=''>
              <em>—</em>
            </MenuItem>
            {options.map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </Select>
          {helperText && (
            <FormHelperText style={helperStyle}>{helperText}</FormHelperText>
          )}
        </FormControl>
      </div>
    );
  }

  if (node.props?.children) {
    const newChildren = React.Children.map(node.props.children, (child) =>
      replaceCustomInputWithSelect(child, options),
    );
    return React.cloneElement(node, node.props, newChildren);
  }

  return node;
};

export default replaceCustomInputWithSelect;
